import FulfillmentSection from 'components/GlobalModals/ChooseOptionsModal/FulfillmentSection/FulfillmentSection';
import { withFulfillmentSectionProps } from 'viewModel/globalModals/chooseOptionsModal/fulfillmentSection/withFulfillmentSectionProps';

export default withFulfillmentSectionProps(FulfillmentSection);
